import { guidebookSteps } from 'components/content/guidebook/content'
import { GuidebookIntro } from 'components/content/guidebook/guidebookIntro/GuidebookIntro'
import { GuidebookLP } from 'components/content/guidebook/GuidebookLP'
import { HeaderDashboard } from 'components/header/headerDashboard/HeaderDashboard'
import { PageTitle } from 'components/PageTitle'
import { ProfileSidebar } from 'components/profile/profileSidebar/ProfileSidebar'
import { SideLayout } from 'components/sideLayout/SideLayout'
import { Spacer } from 'components/spacer/Spacer'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { useSectionsInHash } from 'utils/hooks'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t } = useTranslation('eol_guide')
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null)
  useSectionsInHash(guidebookSteps, scrollElement)

  return (
    <SideLayout left={<ProfileSidebar />} header={<HeaderDashboard />} ref={setScrollElement}>
      <PageTitle title={t('eol_guide.meta_title')} />

      <Spacer size={[1, 0]} />

      <GuidebookIntro noFullPageScroll />

      <Spacer size={4} />

      <GuidebookLP hideSignup />
    </SideLayout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, 'eol_guide', true)) } }
}
